<template>
  <div>
    <h2 class="ViewHeading">Company Admin</h2>
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab active>
            <template #title>
              Companies
            </template>
            <b-card-text>
              <b-card-Group>
                <b-table
                  sticky-header
                  id="CompanyTable"
                  :items="companyArray"
                  :fields="fields"
                  no-border-collapse
                  hover
                  show-empty
                  empty-text="You currently dont have any companies"
                  responsive
                  small
                >
                  <template v-slot:cell(Edit)="{ item }">
                    <b-button
                      variant="outline-info"
                      size="sm"
                      v-on:click="showCompanyModal(item, 'Edit')"
                    >
                      <BIconPencilSquare> </BIconPencilSquare>
                    </b-button>
                  </template>
                  <template v-slot:cell(Action)="{ item }">
                    <b-button
                      v-if="item.Status == 'Active'"
                      variant="outline-danger"
                      size="sm"
                      v-on:click="showCompanyModal(item, 'Remove')"
                    >
                      <BIconXSquare> </BIconXSquare>
                    </b-button>
                    <b-button
                      v-if="item.Status != 'Active'"
                      variant="outline-success"
                      size="sm"
                      v-on:click="showCompanyModal(item, 'Active')"
                    >
                      <BIconCheckSquare> </BIconCheckSquare>
                    </b-button>
                  </template>
                </b-table>
                <b-row>
                  <b-col>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      @click="showCompanyModal('','Add')"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Add New Company
                    </b-button>
                  </b-col>
                </b-row>
              <br/>

                <b-modal
                  ref="AddCompanyForm"
                  id="AddCompanyForm"
                  title="Add Company Form"
                  content-class="Modal"
                  header-bg-variant="light"
                  footer-bg-variant="light"
                  lazy
                  ok-only
                  hide-footer
                >
                <b-card v-if="this.submitted == false">
                  <div class="d-flex justify-content-center mb-3">
                  <b-spinner label="Submitting..."></b-spinner>
                  <br/>
                  <h3>Submitting...</h3>
                  </div>
                  </b-card>
                  <b-card
                    border-variant="dark"
                    align="center"
                    header-bg-variant="secondary"
                    footer-tag="footer"
                    v-if="this.submitted == true"
                  >
                    <template #header>
                      <h4 class="#">Add Company Form</h4>
                    </template>
                    <b-card>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company Name</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Company Name"
                            v-model="newCompany.CompanyName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company Address</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Address"
                            v-model="newCompany.Address"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company Contact</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Contact Name"
                            v-model="newCompany.ContactName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Contact Email</p>
                        </b-col>
                        <b-col sm="8">

                          <input
                            type="text"
                            placeholder="Email Address"
                            v-model="newCompany.ContactEmail"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Contact Telephone</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Telephone"
                            v-model="newCompany.CompanyTele"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Subscritpion Rate (Optional)</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Subscription Rate"
                            v-model="newCompany.SubRate"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                    </b-card>
                    <br />

                    <br />
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="addNewCompany()"
                        >
                          Submit
                        </b-button>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="ClearCompanyModal()"
                        >
                          Clear
                        </b-button>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="cancelModal('Add')"
                        >
                          Cancel
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-modal>
              </b-card-Group>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
      <!-------------------------------------------------------------------------------------------------------------------- 
-->



      <b-modal
        ref="EditCompany"
        id="EditCompany"
        hide-footer
        title="Edit Company"
        content-class="Modal"
      >
      <b-card
                    border-variant="dark"
                    align="center"
                    header-bg-variant="secondary"
                    footer-tag="footer"
                  >
                    <template #header>
                      <h4 class="#">Edit Company</h4>
                    </template>
                    <b-card>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company Name</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Company Name"
                            v-model="companyitem.CompanyName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company Address</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Address"
                            v-model="companyitem.BuildingName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company Contact</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Contact Name"
                            v-model="companyitem.EscalationName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Contact Email</p>
                        </b-col>
                        <b-col sm="8">

                          <input
                            type="text"
                            placeholder="Email Address"
                            v-model="companyitem.EscalationEmail"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Contact Telephone</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Telephone"
                            v-model="companyitem.EscalationPhone"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Subscritpion Rate (Optional)</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Subscription Rate"
                            v-model="companyitem.SubscriptionRate"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                    </b-card>
                    <br />
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="EditCompany(companyitem)"
                        >
                          Submit
                        </b-button>
                      </b-col>
                      <b-col>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="cancelModal('Edit')"
                        >
                          Cancel
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>
          <br />
      </b-modal>

      <b-modal
        ref="CompanyStatus"
        id="CompanyStatus"
        hide-footer
        title="Company Status"
        content-class="Modal"
      >
      <b-card
                    border-variant="dark"
                    align="center"
                    header-bg-variant="secondary"
                    footer-tag="footer"
                  >
                    <template #header>
                      <h4 class="#">Company Status</h4>
                    </template>
                    <b-card>
                       <b-row>
                        <b-col sm="5">
                          <p id="FormText">Company Name</p>
                        </b-col>
                        <b-col sm="7">
                          {{ companyitem.CompanyName }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="5">
                          <p id="FormText">Company Address</p>
                        </b-col>
                        <b-col sm="7">
                          {{ companyitem.BuildingName }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="5">
                          <p id="FormText">Company Contact</p>
                        </b-col>
                        <b-col sm="7">
                          {{ companyitem.EscalationName }}
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="5">
                          <p id="FormText">Company Contact Email</p>
                        </b-col>
                        <b-col sm="7">
                          {{ companyitem.EscalationEmail }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="5">
                          <p id="FormText">Company Telephone</p>
                        </b-col>
                        <b-col sm="7">
                          {{ companyitem.EscalationPhone }}

                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="5">
                          <p id="FormText">Subscritpion Rate (Optional)</p>
                        </b-col>
                        <b-col sm="7">
                          {{ companyitem.SubscriptionRate }}
                        </b-col>
                      </b-row> 
                    </b-card>
                    <br />

                    <br />
                    <b-row>
                      <b-col  v-if="companyitem.Status == 'Active'">
                        <b-button
                          variant="outline-danger"
                          v-on:click="RemoveCompany(companyitem)"
                        >
                          Delete
                        </b-button>
                      </b-col>
                      <b-col  v-if="companyitem.Status == 'Inactive'">
                        <b-button
                          variant="outline-success"
                          v-on:click="ActivateCompany(companyitem)"
                        >
                          Activate
                        </b-button>
                      </b-col>
                      <b-col>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="cancelModal('Remove')"
                        >
                          Cancel
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>


      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconPencilSquare,
  BIconXSquare,
  BIconPlusSquare,
  BIconCheckSquare,
} from "bootstrap-vue";
export default {
  components: {
    BIconPencilSquare,
    BIconXSquare,
    BIconPlusSquare,
    BIconCheckSquare,
  },
  methods: {

    showCompanyModal(item,Action){

      this.companyitem = item

      if (Action == "Add"){
        this.$refs['AddCompanyForm'].show();
      }
      if (Action == "Edit"){
        this.$refs["EditCompany"].show(this.companyitem)
      }
      else if (Action == "Remove"){
        this.$refs["CompanyStatus"].show(this.companyitem)
      }
      else if(Action == "Active"){
        this.$refs["CompanyStatus"].show(this.companyitem)
      }

    },
    cancelModal(Modal){
      if (Modal == "Add"){
        this.$refs["AddCompanyForm"].hide()
        this.ClearCompanyModal();
      }
      if (Modal == "Remove"){
        this.$refs["CompanyStatus"].hide()
      }
      if (Modal == "Edit"){
        this.$refs["EditCompany"].hide()
      }
      if (Modal == "Active"){
        this.$refs['CompanyStatus'].hide()
      }
    },

    ClearCompanyModal() {
      this.newCompany = {
        CompanyName: "",
        Address: "",
        ContactName: "",
        ContactEmail: "",
        CompanyTele: "",
        SubRate: "",
      };
    },

    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    resetForm(action) {
      if (action == "Add"){
        this.$refs["AddCompanyForm"].hide();
      }
      else if(action == "Edit"){
        this.$refs["EditCompany"].hide();
      }
      else{
        this.$refs["CompanyStatus"].hide();
      }
      
      this.newCompany = {
        CompanyName: "",
        Address: "",
        ContactName: "",
        ContactEmail: "",
        CompanyTele: "",
        SubRate: "",
      };
      let LookUpUrlExistingCompany =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpHeadersExistingCompany = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "ParentChildCompanies",
        RequestVariable: this.ParentCompany,
      };
      axios
        .post(
          LookUpUrlExistingCompany,
          this.LookUpRequest,
          LookUpHeadersExistingCompany
        )
        .then((response) => {
          this.companyArray = []
          this.companyList = []
          this.companyList = response.data.Values;

          for (let i = 0; i < this.companyList.length; i++) {
            this.companyArray.push({
              CompanyName: this.companyList[i][0],
              Status: this.companyList[i][1],
              BuildingName: this.companyList[i][2],
              EscalationName: this.companyList[i][3],
              EscalationEmail: this.companyList[i][4],
              EscalationPhone: this.companyList[i][5],
              SubscriptionStatus: this.companyList[i][6],
              SubscriptionRate: this.companyList[i][7],
              ID: this.companyList[i][8],
            });
          }
        });
    },

    addNewCompany() {
      this.submitted = false
      let LookUpURLNewCompany =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersNewCompany = this.$apikeyPost;
      let LookUpRequestNewCompany = {
        RequestType: "Company",
        Action: "Create",
        DataDict: [
          {
            CompanyName: this.newCompany.CompanyName,
            CompanyAddress: this.newCompany.Address,
            CompanyContact: this.newCompany.ContactName,
            CompanyEmail: this.newCompany.ContactEmail,
            CompanyTel: this.newCompany.CompanyTele,
            SubscriptionRate: this.newCompany.SubRate,
            ParentCompany: this.ParentCompany
          },
        ],
      };
      axios
        .post(
          LookUpURLNewCompany,
          LookUpRequestNewCompany,
          LookUpHeadersNewCompany
        )
        .then((response) => {
          response;
          this.submitted = true
          alert("Company has been added");
          this.resetForm("Add");
        });
    },


    EditCompany(item) {

      let LookUpURLEditCompany =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersEditCompany = this.$apikeyPost;
      let LookUpRequestEditCompany = {
        RequestType: "Company",
        Action: "Edit",
        DataDict: [
          {
            CompanyName: item.CompanyName,
            CompanyAddress: item.BuildingName,
            CompanyContact: item.EscalationName,
            CompanyEmail: item.EscalationEmail,
            CompanyTel: item.EscalationPhone,
            SubscriptionRate: item.SubscriptionRate,
            SubscriptionStatus: item.SubscriptionStatus,
            CompanyID: item.ID,
          },
        ],
      };
      axios
        .post(
          LookUpURLEditCompany,
          LookUpRequestEditCompany,
          LookUpHeadersEditCompany
        )
        .then((response) => {
 
          response;

          alert("Company has been edited");
          this.resetForm("Edit");
        });
    },
    ActivateCompany(item){
      let LookUpURLActivateCompany =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersActivateCompany = this.$apikeyPost;
      let LookUpRequestActivateCompany = {
        RequestType: "Company",
        Action: "Activate",
        DataDict: [{ CompanyName: item.CompanyName }],
      };
      axios
        .post(
          LookUpURLActivateCompany,
          LookUpRequestActivateCompany,
          LookUpHeadersActivateCompany
        )
        .then((response) => {
          response;
          alert("Company has been Reactivated");
          this.resetForm("activate");
        });
    },

    RemoveCompany(item) {
      let LookUpURLDeleteCompany =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDeleteCompany = this.$apikeyPost;
      let LookUpRequestDeleteCompany = {
        RequestType: "Company",
        Action: "Delete",
        DataDict: [{ CompanyName: item.CompanyName }],
      };
      axios
        .post(
          LookUpURLDeleteCompany,
          LookUpRequestDeleteCompany,
          LookUpHeadersDeleteCompany
        )
        .then((response) => {
          response;

          alert("Company has been Deactivated");
          this.resetForm("remove");
        });
    },

    /* existing Methods */

    HistorySubmit() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };

      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
        });
    },
  },

  mounted() {
    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }

    /* Company Look Up */

    let LookUpUrlExistingCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingCompany = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentChildCompanies",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingCompany,
        this.LookUpRequest,
        LookUpHeadersExistingCompany
      )
      .then((response) => {
        this.companyList = response.data.Values;

        for (let i = 0; i < this.companyList.length; i++) {
          this.companyArray.push({
            CompanyName: this.companyList[i][0],
            Status: this.companyList[i][1],
            BuildingName: this.companyList[i][2],
            EscalationName: this.companyList[i][3],
            EscalationEmail: this.companyList[i][4],
            EscalationPhone: this.companyList[i][5],
            SubscriptionStatus: this.companyList[i][6],
            SubscriptionRate: this.companyList[i][7],
            ID: this.companyList[i][8],
          });
        }
      });

  },

  data() {
    return {
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: this.$Company,
      clDept: "",
      clLocation: "",
      clEmail: "",
      clURN: "",
      UserFirstNameSearch: "",
      UserSurnameSearch: "",
      deactclURN: "",
      deactclFName: "",
      deactclLName: "",
      deactclDept: "",
      deactclLoc: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      contactLocation: this.$Location,
      DeviceRequestNo: "",
      userName: this.$FullName,
      BMULocationRemove: "",
      UserURN: this.$UserURN,
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      messageforNewLocationEmail: "",
      selectedSearch: "",
      UserProfile: this.$ProfilePortal,
      companyArray: [],
      companyList: [],

      compTele: "",
      compEmail: "",
      compContactName: "",
      compAddress: "",
      compName: "",
      compSubRate: "",
      companytoEdit: "",
      companyToDeleteList: [],
      companytoDelete: "",
      deletedCompany: "",

      insFName: "",
      insLName: "",
      insEmail: "",
      insCompany: localStorage.getItem("Company"),
      insURN: "",

      locRegion: [],
      editLocCountry: "",
      selectedAction: "",
      HistoryNote: "", 
      newCompany: {
        CompanyName: "",
        Address: "",
        ContactName: "",
        ContactEmail: "",
        CompanyTele: "",
        SubRate: "",
      },
      optionsinstallers: [],

      clientitems: [],

      fields: [
        { key: "CompanyName", variant: "primary", label: "Name"},
        { key: "BuildingName", label: "Address" },
        { key: "EscalationName", label: "Contact" },
        { key: "EscalationEmail", label: "Email" },
        { key: "Status" },
        { key: "Edit" },
        { key: "Action" },
      ],
      clientData: "",
      clientAction: "",
      options: [],
      locationArray: [],
      selected: "",
      clearUserData: [],

      // Just to stop the stupid errors

      deactInsUsername: "",
      InsUsername: "",
      InsLName: "",
      InsFName: "",
      AccessGroupArray: [],
      ParentCompany: localStorage.getItem("ParentCompany"),
      companyitem:"",
      submitted: true,
    };
  },

  watch: {
    location() {
      this.filterLocations();
    },

  },
};
</script>

<style scoped></style>
